import { createContext, useContext, Dispatch, SetStateAction } from 'react';

interface Context {
  isPageVariantLoading: boolean;
  setPageVariantLoading: Dispatch<SetStateAction<boolean>>;
  isPageStatsLoading: boolean;
  setPageStatsLoading: Dispatch<SetStateAction<boolean>>;
}

const defaultContext: Context = {
  isPageVariantLoading: true,
  setPageVariantLoading: () => null,
  isPageStatsLoading: true,
  setPageStatsLoading: () => null
};

export const PageLoaderContext = createContext(defaultContext);

export const usePageLoaderContext = () => useContext(PageLoaderContext);

export const hideLoader = (selectorId: string) => {
  const loader: HTMLElement | null = document.querySelector(`#${selectorId}`);
  if (loader) {
    loader.style.opacity = '0';
    setTimeout(() => {
      loader.parentNode!.removeChild(loader);
    }, 200);
  }
};
